export default __webpack_public_path__ + "static/media/student4.90637da4.gif";